import React from 'react';
import { useNavigate } from 'react-router-dom';


const NoAccessPage = () => {
  const navigate = useNavigate();

  return (
    <div className="flex items-center justify-center min-h-screen bg-gray-100">
      <div className="text-center p-6 bg-white shadow-md rounded-lg">
        <h1 className="text-4xl font-customFont text-custom_primary mb-4">
          Access Denied
        </h1>
        <p className="text-lg text-placeholderColor">
          You don't have access to this page.
        </p>
        <button 
          className="mt-6 px-4 py-2 bg-custom_primary text-white rounded hover:bg-opacity-90"
          onClick={() => navigate(-2)}
        >
         Go Back
        </button>
      </div>
    </div>
  );
};

export default NoAccessPage;
